import LieuLabel from '@/generated/controls/lieu/LieuLabel.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: LieuLabel
})
